import { httpClient } from '../httpClient';
export class AuthenicateRepository {
    async login(params) {
        const { data } = await httpClient.post('authenicate/login', JSON.stringify(params));
        return data;
    }
    async temporaryLoginByConfrimLoginInfo(params) {
        const { data } = await httpClient.post('authenicate/confirm/login-user-info', JSON.stringify(params));
        return data;
    }
    async temporaryLoginByResetLoginInfo(params) {
        const { data } = await httpClient.post('authenicate/reset/login-user-info', JSON.stringify(params));
        return data;
    }
    async temporaryLoginByResetLoginInfoReminders(params) {
        const { data } = await httpClient.post('authenicate/reset/login-user-info/reminders', JSON.stringify(params));
        return data;
    }
}
